var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 12C11.4286 11.6094 11.1049 11.2857 10.7143 11.2857H0.714286C0.323661 11.2857 0 11.6094 0 12C0 12.1897 0.078125 12.3683 0.212054 12.5022L5.21205 17.5022C5.34598 17.6362 5.52455 17.7143 5.71429 17.7143C5.90402 17.7143 6.08259 17.6362 6.21652 17.5022L11.2165 12.5022C11.3504 12.3683 11.4286 12.1897 11.4286 12ZM11.4286 7.71429C11.4286 7.52455 11.3504 7.34598 11.2165 7.21205L6.21652 2.21205C6.08259 2.07812 5.90402 2 5.71429 2C5.52455 2 5.34598 2.07812 5.21205 2.21205L0.212054 7.21205C0.078125 7.34598 0 7.52455 0 7.71429C0 8.10491 0.323661 8.42857 0.714286 8.42857H10.7143C11.1049 8.42857 11.4286 8.10491 11.4286 7.71429Z",
    fill: "#CB998D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.1f0457f197f89a0c6140018514f82f68.svg";
export { ForwardRef as ReactComponent };